import { render, staticRenderFns } from "./kinh-doanh-van-phong.vue?vue&type=template&id=7e2570d0"
import script from "./kinh-doanh-van-phong.vue?vue&type=script&lang=js"
export * from "./kinh-doanh-van-phong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports